export const SaveFailure = {
    SESSION_EXPIRED: 'session_expired',
    UNEXPECTED: 'unexpected'
};
